export function getValueForBreakpoint(breakpointIndex, arrayOrValue) {
  if (!Array.isArray(arrayOrValue)) return arrayOrValue;
  var maxIndex = arrayOrValue.length - 1;
  var index = breakpointIndex > maxIndex ? maxIndex : breakpointIndex;
  return arrayOrValue[index];
}